<template>
<v-footer
    dark
    height="auto"
    style="background: #00072F;"
>
  <v-container>
    <v-layout row wrap mt-4 mb-4 >
      <v-flex xs12 sm6>
        <v-flex xs12>
          <img
              class="foot-logo"
              src="/static/images/enter_logo.svg"
              title="enter.online"
              alt="Enter"
          >
        </v-flex>
        <v-flex xs12>
          <a
            href="https://enter.online"
            title="Enter"
            target="_blank"
            class="parent-site"
          >www.enter.online
          </a>
        </v-flex>
      </v-flex>
      <v-flex xs12 sm6 class="text-xl-right text-sm-center">
        <v-flex xs12>
          <v-btn
              icon
              round
              large
              ripple
              style="background-color: rgba(255, 255, 255, .3) !important;"
              href="https://www.facebook.com/enter.moldova/"
              target="_blank"
          >
           <img src="/static/images/facebook.svg" alt="" />
          </v-btn>
          <v-btn
              icon
              round
              large
              ripple
              style="background-color: rgba(255, 255, 255, .3) !important;"
              href="https://www.youtube.com/channel/UCVlxjWAjATl7xSCnanXIxxg"
              target="_blank"
          >
           <img src="/static/images/youtube.svg" alt="" />
          </v-btn>
          <v-btn
              icon
              round
              large
              ripple
              style="background-color: rgba(255, 255, 255, .3) !important;"
              href="https://www.instagram.com/entermoldova/"
              target="_blank"
          >
           <img src="/static/images/instagram.svg" alt="" />
          </v-btn>
          <v-btn
              icon
              round
              large
              ripple
              style="background-color: rgba(255, 255, 255, .3) !important;"
              href="https://t.me/enteronline"
              target="_blank"
          >
           <img src="/static/images/telegram.svg" alt="" />
          </v-btn>
        </v-flex>
        <v-flex xs12 mt-3>
          <div class="footer-contact">
            {{ $t('footer.contact') }}
            <span><a href="tel:068800900">0 (68) 800 910</a></span>
          </div>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
  <v-dialog v-model="dialog" width="1000">
    <v-card class="offerta" height="450">
      <a href="javascript:void(0)" class="ui-top-right" @click="dialog = false">
        <v-icon dark>close</v-icon>
      </a>
      <v-card-text>
        <h3 v-if="$i18n.locale === 'ro'">
          Pentru fanii adevărați<br>
          reduceri reale de Black Friday!
        </h3>
        <h3 v-else>
          Для настоящих болельщиков<br>
          настоящие скидки в Black Friday!
        </h3>
        <p v-if="$i18n.locale === 'ro'">
          Reduceri la electrocasnice și gadgeturi
        </p>
        <p v-else>
          Скидки на бытовую технику и гаджеты
        </p>
        <v-btn flat v-if="$i18n.locale === 'ro'" href="https://enter.online/black-friday" target="_blank">
          Detalii
        </v-btn>
        <v-btn flat v-else href="https://enter.online/ru/chernaja-pjatnica " target="_blank">
          Подробнее
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-footer>
</template>

<script>
export default {
  name: 'mainFooter',
  data () {
    return {
      dialog: false
    }
  }
  // created () {
  //   if (localStorage.getItem('telegram')) {
  //     setTimeout(() => {
  //       this.dialog = true
  //     }, 40000)
  //   }
  // }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/mainFooter.vue